export default __webpack_public_path__ + "static/media/pagseg.5ff09f11.png";